// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project import
import menu from './menu';
import properties from './propertySlice';
import comparables from './comparablesSlice';
import zoom from './zoomSlice';
import askingPrices from './askingPricesSlice';
import selectedComparables from './selectedComparablesSlice';
import account from './accountSlice';
import adminAuth from './adminAuthSlice';
import adminUsers from './adminUsersSlice';
import adminDb from './adminDbSlice';
import adminInsights from './adminInsightsSlice';
import adminFeedback from './adminFeedbackSlice';

// ==============================|| COMBINE REDUCERS ||============================== //

const accountPersistConfig = {
  key: 'account',
  storage,
  keyPrefix: 'realescy-'
};

const reducers = combineReducers({
  menu,
  properties,
  comparables,
  zoom,
  askingPrices,
  selectedComparables,
  account: persistReducer(accountPersistConfig, account),
  adminAuth,
  adminUsers,
  adminDb,
  adminInsights,
  adminFeedback
});

export default reducers;
